import React, { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { isEmpty } from 'lodash-es';
import queryString from 'query-string';
import { BaseBox, CenterBox, Heading2, Heading4 } from '@docon/docon-ui-library';
import { getPrescriptions } from 'redux/reducer/prescription';
import Card from './Card';
import Prescription from './Prescription';
import Layout from 'components/Layout';
import { Image, Loader } from 'shared';

// function getDaysFromVisit(data: any) {
//   const obj = data.visit;
//   const todaysDate = moment();
//   return moment(obj['dateTimeISO'], 'YYYY-MM-DD HH:mm:ss ZZ').diff(todaysDate, 'days');
// }

const Root = styled(Layout)`
  .year {
    font-weight: 600;
    margin-left: 5px;
    margin-bottom: 15px;
  }

  .zeroCase {
    position: relative;
    top: 40%;
    text-align: center;
    transform: translateY(-50%);

    ${CenterBox} {
      img {
        max-width: 100%;
      }
    }

    ${Heading4} {
      opacity: 0.6;
    }
  }
`;

function RecordsComponent() {
  const { visitId } = queryString.parse(location.search);
  const { user } = useSelector(state => state.auth);
  const [activeVisit, setActiveVisit] = useState<any>({});

  const {
    visits,
    years,
    visitByYear,
    isFetchingPrescription,
  } = useSelector(state => state.prescription);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPrescriptions(user.userID));
  }, []);

  useEffect(() => {
    if (visitId) {
      const visit = visits.find(visit => visit.visitID === visitId);
      setActiveVisit(visit);
    }
  }, [visits]);

  function handleCardClick({ visit }: any) {
    setActiveVisit(visit);
  }

  function handleClosePrescription() {
    setActiveVisit({});
  }

  function renderContent() {
    if (isFetchingPrescription) {
      return <Loader />;
    }

    if (isEmpty(visits)) {
      return (
        <BaseBox className='zeroCase'>
          <CenterBox>
            <Image src='/images/empty-states/no-rx@2x.png' alt='' />
          </CenterBox>
          <Heading2 fontWeight={600} m={'16px 0 5px'} title='Nothing prescribed' />
          <Heading4 title='You have no prescriptions' />
        </BaseBox>
      );
    }

    return (
      <>
        {
          years.map((year: string) => (
            <Fragment key={year}>
              <Heading2 className='year' title={year} />

              {
                visitByYear[year].map((visit: any) => (
                  <Card
                    key={visit.visitID}
                    type='prescription'
                    visit={visit}
                    onClick={handleCardClick}
                  />
                ))
              }
            </Fragment>
          ))
        }
      </>
    );
  }

  return (
    <Root>
      {
        !isEmpty(activeVisit) ? (
          <Prescription
            visitID={activeVisit.visitID}
            source={'prescription'}
            patientID={activeVisit.patient.patientID}
            doctorID={activeVisit.doctorID}
            mobileNumber={activeVisit?.patient?.mobileNumber}
            onClose={handleClosePrescription}
          />
        ) : null
      }
      {renderContent()}
    </Root>
  );
}

export default RecordsComponent;